// Applies the equipped cosmetics (block palette + background theme) to the page.
// Subscribes to storage so a purchase or a cross-device sync updates the look
// live, with no re-render of any game (games style themselves via the global
// CSS vars / the data-bg-theme attribute).

import { subscribe, getCosmetics } from "./storage";
import { getPalette } from "./palette";

let lastPalette = "";
let lastBackground = "";

/** Call once in src/main.ts, before mountShell, to avoid a color flash. */
export function initCosmetics(): void {
  // subscribe fires immediately with the current state, so this applies now
  // and again on every storage change (purchases, equips, remote updates).
  subscribe(() => apply());
}

function apply(): void {
  const { palette, background } = getCosmetics().equipped;
  const root = document.documentElement;

  if (palette !== lastPalette) {
    lastPalette = palette;
    getPalette(palette).colors.forEach((c, i) => root.style.setProperty(`--game-c${i + 1}`, c));
  }

  if (background !== lastBackground) {
    lastBackground = background;
    if (background === "default") delete root.dataset.bgTheme;
    else root.dataset.bgTheme = background;
  }
}
